import useAdminFactures from "../../hooks/use-admin-factures";
import Card from "../UI/Card";
import { currencyFormatter } from "../../api/Functions";
import Button from "../UI/Button";
import { useModal } from "../../hooks/use-modal.jsx";
import GenerateFactureForm from "./GenerateFactureForm";

export default function AdminFactures() {
  const { factures, generateFacture } = useAdminFactures();
  const [
    GenerateFactureModal,
    closeGenerateFactureModal,
    openGenerateFactureModal,
  ] = useModal();

  async function generateFactureHandler(values) {
    await generateFacture(values, {
      sort: (a, b) => b.numero_facture - a.numero_facture,
    });
    closeGenerateFactureModal();
  }

  const total = factures.reduce((acc, facture) => acc + facture.montant, 0);

  return (
    <>
      <GenerateFactureModal>
        <GenerateFactureForm onSubmit={generateFactureHandler} />
      </GenerateFactureModal>
      <Card>
        <Button onClick={openGenerateFactureModal} className={"marginB10"}>
          Générer une facture
        </Button>
        <p className={"primaryText marginB10"}>
          Total facturé : {currencyFormatter(total)}
        </p>
        {factures.map((facture, i) => (
          <div key={i}>
            <span>{facture.date_add}</span> - <span>{facture.id_compte}</span>
            {" - "}
            <span>{currencyFormatter(facture.montant)}</span> -{" "}
            <span>{facture.numero_facture}</span>
          </div>
        ))}
      </Card>
    </>
  );
}
